import React from 'react'
import { Redirect, RouteComponentProps } from 'react-router'
import { Routes } from '../routes'

interface HomeProps extends RouteComponentProps {}

export const Home: React.FC<HomeProps> = () => {
  return <Redirect to={Routes.login} />
}
